// Tabla 40 - Tipo de pago
// TransUnion - Tablas de convenciones - Información Comercial - Versión 1.34

const tipoPago = {
  VOL: 'Voluntario',
  NVO: 'No voluntario'
};

export default tipoPago;
